import { Component, Input } from '@angular/core';

@Component({ selector: 'app-recipient-loading-skeleton', templateUrl: './recipient-loading-skeleton.component.html',
  styleUrls: ['./recipients.scss', './recipient-loading-skeleton.component.scss'] })
export class RecipientLoadingSkeletonComponent {
  @Input() mode: 'list' | 'detail' | 'updates' = 'list';
}
